export default {
  err: 'Erreur',
  back: 'Retour',
  next: 'Suivant',
  save: 'Enregistrer',
  delete: 'Supprimer'
}
